import { Box } from '@mui/material';
import { type StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';
import { COLORS_MAP, SPACING_MAP } from './constants';
import type { SpacingToken, SpacingValue } from './types';
import type { ColorToken } from '../../types';

export type ContainerProps = StructuredContentDocument<{
  margin?: SpacingToken;
  padding?: SpacingToken;
  marginTop?: SpacingToken;
  marginBottom?: SpacingToken;
  marginLeft?: SpacingToken;
  marginRight?: SpacingToken;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
  paddingLeft?: SpacingToken;
  paddingRight?: SpacingToken;
  backgroundColor?: ColorToken;
  color?: ColorToken;
  children: StructuredContentDocument;
}>;

export const Well = ({ props }: ContainerProps) => {
  const { children, color, backgroundColor, ...spacingProps } = props;

  const spacingMap = Object.entries(spacingProps).reduce<Record<string, SpacingValue>>(
    (acc, [prop, value]) => {
      acc[prop] = SPACING_MAP[value];
      return acc;
    },
    {},
  );

  const containerColor = backgroundColor ?? color;

  return (
    <Box sx={{ bgcolor: COLORS_MAP[containerColor ?? 'green-lighter'], ...spacingMap }}>
      <StructuredContentRenderer doc={children} />
    </Box>
  );
};
